// @flow
import i18n from 'i18next';

export const PDFS = {
  advertisingTerms: {
    fr: () => require('../assets/pdfs/follo/fr/advertising-terms.fr.pdf'),
    en: () => require('../assets/pdfs/follo/en/advertising-terms.en.pdf'),
    default: () => require('../assets/pdfs/follo/en/advertising-terms.en.pdf'),
  },
  folloCreateCampaign: {
    fr: () => require('../assets/pdfs/follo/fr/01-Follo-creation-campagne.pdf'),
    en: () => require('../assets/pdfs/follo/en/01-Follo-create-campaign.pdf'),
    default: () => require('../assets/pdfs/follo/en/01-Follo-create-campaign.pdf'),
  },
  folloAddTimesCampaign: {
    fr: () => require('../assets/pdfs/follo/fr/02-Follo-ajout-heures-diffusion.pdf'),
    en: () => require('../assets/pdfs/follo/en/02-Adding-broadcast-times-campaign.pdf'),
    default: () => require('../assets/pdfs/follo/en/02-Adding-broadcast-times-campaign.pdf'),
  },
  folloCampaignStatistics: {
    fr: () => require('../assets/pdfs/follo/fr/03-Follo-Acces-performance-campagne.pdf'),
    en: () => require('../assets/pdfs/follo/en/03-Follo-Access-campaign-performance.pdf'),
    default: () => require('../assets/pdfs/follo/en/03-Follo-Access-campaign-performance.pdf'),
  },
  folloFinishCampaign: {
    fr: () => require('../assets/pdfs/follo/fr/04-Follo-Terminer-campagne.pdf'),
    en: () => require('../assets/pdfs/follo/en/04-Follo-Complete-campaign.pdf'),
    default: () => require('../assets/pdfs/follo/en/04-Follo-Complete-campaign.pdf'),
  },
  folloAdvertiser: {
    fr: () => require('../assets/pdfs/follo/fr/Follo_annonceur.pdf'),
    en: () => require('../assets/pdfs/follo/en/Follo_advertiser.pdf'),
    default: () => require('../assets/pdfs/follo/en/Follo_advertiser.pdf'),
  },
  folloPlateform: {
    fr: () => require('../assets/pdfs/follo/fr/Plateforme-achat-tutoriel.pdf'),
    en: () => require('../assets/pdfs/follo/fr/Plateforme-achat-tutoriel.pdf'),
    default: () => require('../assets/pdfs/follo/fr/Plateforme-achat-tutoriel.pdf'),
  },
  theGuide: {
    fr: () => require('../assets/pdfs/fr/StatsRadio_LeGuide_Fr.pdf'),
    en: () => require('../assets/pdfs/en/StatsRadio_TheGuide_En.pdf'),
    default: () => require('../assets/pdfs/en/StatsRadio_TheGuide_En.pdf'),
  },
  dataDisseminationRules: {
    fr: () => require('../assets/pdfs/fr/StatsRadio_ReglesDiffusionDonnees.pdf'),
    en: () => require('../assets/pdfs/en/StatsRadio_DataDisseminationRules.pdf'),
    default: () => require('../assets/pdfs/en/StatsRadio_DataDisseminationRules.pdf'),
  },
};

function getPDFUrl(pdf: string) {
  const language = i18n.language;

  const pdfs = PDFS[pdf];
  if (!pdfs) {
    return undefined;
  }

  return (pdfs[language] || pdfs.default)();
}

const PDFS_IMPORTERS = Object.keys(PDFS)
  .reduce((acc, pdf) => {
    acc[pdf] = () => getPDFUrl(pdf);
    return acc;
  }, {});

export default PDFS_IMPORTERS;



// WEBPACK FOOTER //
// ./src/statsradio/modules/tutorials/domain/pdfs.js